import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Step shell — wraps each wizard step with:
 *   • Title + subtitle
 *   • Optional in-step content
 *   • Back + Continue buttons (omit / customize per step)
 *   • Slide-in entrance animation
 *
 * Each step only renders when active so previous steps don't sit
 * in the DOM behind it.
 */
export default function StepShell({
  title,
  subtitle,
  children,
  onBack,
  onContinue,
  backLabel = "Back",
  continueLabel = "Continue",
  showBack = true,
  showContinue = true,
  continueDisabled = false,
  testIdPrefix = "byod-step",
  extraActions = null,
}) {
  return (
    <div className="ssc-byod-step animate-byod-slide-in" data-testid={testIdPrefix}>
      <div className="mb-5 sm:mb-7">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-[var(--ssc-navy)] leading-tight" data-testid={`${testIdPrefix}-title`}>
          {title}
        </h2>
        {subtitle && (
          <p className="mt-2 text-sm sm:text-base text-[var(--ssc-ink-2)] leading-relaxed max-w-3xl" data-testid={`${testIdPrefix}-subtitle`}>
            {subtitle}
          </p>
        )}
      </div>

      <div>{children}</div>

      {(showBack || showContinue || extraActions) && (
        <div className="mt-6 sm:mt-8 flex items-center justify-between gap-3 flex-wrap" data-testid={`${testIdPrefix}-actions`}>
          <div>
            {showBack && (
              <button
                type="button"
                onClick={onBack}
                className="ssc-btn ssc-btn-outline"
                data-testid={`${testIdPrefix}-back`}
              >
                <ChevronLeft size={16} /> {backLabel}
              </button>
            )}
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            {extraActions}
            {showContinue && (
              <button
                type="button"
                onClick={onContinue}
                disabled={continueDisabled}
                className="ssc-btn ssc-btn-primary"
                data-testid={`${testIdPrefix}-continue`}
              >
                {continueLabel} <ChevronRight size={16} />
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
